export default "__VITE_ASSET__SSQBVjSq__"